import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import "./sidebar-submenu.scss";

/**
 * SidebarSubmenu Component
 * Displays a list of submenu items for sidebar navigation
 */
const SidebarSubmenu = ({ title, items, onItemClick }) => (
	<div className="sidebar-submenu" role="menu" aria-label={title}>
		{title && <span className="sidebar-submenu__title">{title}</span>}
		<ul className="sidebar-submenu__list">
			{items.map(({ route, icon, label, description }) => (
				<li key={route} className="sidebar-submenu__item">
					<NavLink
						to={route}
						className="sidebar-submenu__link"
						activeClassName="sidebar-submenu__link--active"
						role="menuitem"
						onClick={onItemClick}
					>
						{icon && <span className="sidebar-submenu__icon">{icon}</span>}
						<span className="sidebar-submenu__text">
							<span className="sidebar-submenu__label">{label}</span>
							{description && (
								<span className="sidebar-submenu__description">
									{description}
								</span>
							)}
						</span>
					</NavLink>
				</li>
			))}
		</ul>
	</div>
);

SidebarSubmenu.propTypes = {
	title: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			route: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			icon: PropTypes.node,
			description: PropTypes.string,
		})
	).isRequired,
	onItemClick: PropTypes.func,
};

SidebarSubmenu.defaultProps = {
	title: "",
	onItemClick: undefined,
};

export default SidebarSubmenu;
